module.exports = __webpack_public_path__ + "static/media/mono_back.03a090db.png";